import { render, staticRenderFns } from "./AppTabs.vue?vue&type=template&id=1d1d595a&"
import script from "./AppTabs.vue?vue&type=script&lang=ts&"
export * from "./AppTabs.vue?vue&type=script&lang=ts&"
import style0 from "./AppTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTabs})
